//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Where a label should be printed */
export const PrintTo = {
    /** Print to the default printer */
    Default: 0,

    /** Print to the printer associated with the selected kiosk */
    Kiosk: 1,

    /** Print to the printer associated with the selected location */
    Location: 2
} as const;

/** Where a label should be printed */
export const PrintToDescription: Record<number, string> = {
    0: "Default",

    1: "Kiosk",

    2: "Location"
};

/** Where a label should be printed */
export type PrintTo = typeof PrintTo[keyof typeof PrintTo];
